import { useEffect, useState } from 'react';
import { useQrStore } from '../../../../../../../store/use-qr-store';
import s from './view.module.css';
import { Select } from '../../../../../../../components/select/select';
import { useLang } from '../../../../../../../hooks/use-lang';
import { IdValue } from '../../../../../../../types/props';
import { getBaseUrl } from '../../../../../../../store/api/utils.ts/stand';
import { Container } from '../../../../../../../components/container/container';
import { Card } from '../../../../../../../components/card/card';

export const PromoView = () => {
  const { fetchQrList, staticList: list } = useQrStore();
  const { getLocale, t } = useLang();
  const [selectedQr, setSelectedQr] = useState<IdValue>();

  useEffect(() => {
    fetchQrList({ is_by_company: true, n: 1000, since_id: 0 });
  }, [fetchQrList]);

  const options = list?.map((item) => ({ id: item.id, value: getLocale(item.name) })) || [];
  const clientUrl = getBaseUrl();

  return (
    <Card className={s.feature} title={`2. ${t('Предпросмотр')}`}>
      <Container label={t('Для начала предпросмотра выберите QR-код')}>
        <Select options={options} value={selectedQr} onSelect={setSelectedQr} />
      </Container>

      {/* {selectedQr?.id && (
        <ShadowDomPreview
          contentUrl={`${clientUrl}/qr/${selectedQr?.id}`}
          style={{ width: '100%', minHeight: '550px' }}
        />
      )} */}
      {selectedQr?.id && (
        <iframe
          title="preview"
          style={{ width: '100%', minHeight: '550px', border: 'none' }}
          src={`${clientUrl}/qr/${selectedQr?.id}`}
        />
      )}
    </Card>
  );
};
